import FORMAT from 'config/date/format';
import moment from 'moment';

const thisyear = datestring => moment(datestring, FORMAT).diff(moment(), 'hours') > 0 && moment(datestring, FORMAT).isSame(moment(), 'year');

export default events => events?.filter(e => thisyear(e.start_date)) || [];